import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import CustomIcon from "../../../components/CustomIcon";
import { TableCell } from "../../../components/table/CustomTable";
import CustomButton, { DangerButton, OutlinedButton } from "../../../components/CustomButton";
import { ComponentNoData } from "../../../components/ComponentLoader";
import { cloneDeep } from "lodash/lang";
import { getUiBreadCrumbFormat, isMobilePlatform, isWebPlatform } from "../dynamicUiFunctions";
import DynamicItemsPaginator from "./DynamicItemsPaginator";
import { PLATFORM_BOTH, PLATFORM_MOBILE, PLATFORM_WEB } from "../../../constants/commons";
import isEmpty from "lodash/isEmpty";

const DynamicItemTableBody = ({ onEditItem, setItemToSelected, setItemClicked }) => {

  const activeTab = useSelector((state) => (state.dynamicUi.items.activeTab));

  const selectedTab = useSelector((state) => (state.dynamicUi.items[activeTab].selected));

  const currentPage = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].meta.page);

  const data = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].pageData[currentPage]?.data) ?? [];

  return (
    <>
      <tbody>
        {data.map((item) =>
          <tr key={`body-item-${item.id}`}>
            <TableBodyItem extClass="w-6">
              <div className="flex items-center">
                <AddRemoveItem item={item} setItemToSelected={setItemToSelected} />
              </div>
            </TableBodyItem>
            <TableBodyItem extClass="pl-0">
              <span className="pr-1">{getUiBreadCrumbFormat(item)}</span>
              {isMobilePlatform(item.platform, true) && <span className="pr-1" title="Mobile Component">
                <CustomIcon icon="phone_iphone" size="xxs"
                  className="text-gray-500 border-dashed border border-sky-200 rounded-full p-1 bg-sky-100" />
              </span>}
              {isWebPlatform(item.platform, true) && <span title="Web Component"><CustomIcon icon="desktop_mac" size="xxs"
                className="text-gray-500 border-dashed border border-sky-200 rounded-full p-1 bg-sky-100" /></span>}
            </TableBodyItem>

            <TableBodyItem extClass="pl-0">
              <div className="flex space-x-2 justify-end items-center">
                <OutlinedButton isIconButton={true} onClick={() => setItemClicked({ ...item, preview: true })}>
                  <CustomIcon icon="visibility" />
                </OutlinedButton>
                <CustomButton isIconButton={true}
                  onClick={() => !item.is_default && onEditItem && onEditItem(cloneDeep({
                    ...item,
                    edit: true
                  }))}
                  disabled={item.is_default}>
                  <CustomIcon icon="edit" />
                </CustomButton>
                <DangerButton isIconButton={true} onClick={() => !item.is_default && setItemClicked({
                  ...item,
                  delete: true
                })} disabled={item.is_default}>
                  <CustomIcon icon="delete" />
                </DangerButton>
              </div>
            </TableBodyItem>
          </tr>
        )}

        {!data?.length &&
          <tr>
            <td colSpan="2">
              <ComponentNoData msg="List is Empty" />
            </td>
          </tr>}

      </tbody>
      <tbody>
        {/*<tr>*/}
        {/*  <td>*/}
        {/*    <ConfirmModal showModal={!!itemClicked?.delete} onConfirm={removeItem} setShowModal={closeModal}*/}
        {/*                  disabled={deleting}>*/}
        {/*      This element will be deleted*/}
        {/*    </ConfirmModal>*/}
        {/*    <PreviewModal showModal={!!itemClicked?.preview ? itemClicked : undefined}*/}
        {/*                  setShowModal={closeModal} add={true} onConfirm={onPreviewAction}/>*/}
        {/*    <AddToSelectedModal showModal={itemToSelected} setShowModal={setItemToSelected}/>*/}
        {/*  </td>*/}
        {/*</tr>*/}
        <tr>
          <td colSpan="3"><DynamicItemsPaginator /></td>
        </tr>

      </tbody>

    </>

  );
};
export default React.memo(DynamicItemTableBody);


const DynamicItemSearchResultTableBody = ({ onEditItem, setItemToSelected, setItemClicked, item }) => {

  return (
    <>
      <tbody>
        {isEmpty(item) ?
          <tr>
            <td colSpan="2">
              <ComponentNoData msg="List is Empty" />
            </td>
          </tr> :
          <tr key={`body-item-${item.id}`}>
            <TableBodyItem extClass="w-6">
              <div className="flex items-center">
                <AddRemoveItem item={item} setItemToSelected={setItemToSelected} />
              </div>
            </TableBodyItem>
            <TableBodyItem extClass="pl-0">
              <span className="pr-1">{getUiBreadCrumbFormat(item)}</span>
              {isMobilePlatform(item.platform, true) && <span className="pr-1" title="Mobile Component">
                <CustomIcon icon="phone_iphone" size="xxs"
                  className="text-gray-500 border-dashed border border-sky-200 rounded-full p-1 bg-sky-100" />
              </span>}
              {isWebPlatform(item.platform, true) && <span title="Web Component"><CustomIcon icon="desktop_mac" size="xxs"
                className="text-gray-500 border-dashed border border-sky-200 rounded-full p-1 bg-sky-100" /></span>}
            </TableBodyItem>

            <TableBodyItem extClass="pl-0">
              <div className="flex space-x-2 justify-end items-center">
                <OutlinedButton isIconButton={true} onClick={() => setItemClicked({ ...item, preview: true })}>
                  <CustomIcon icon="visibility" />
                </OutlinedButton>
                <CustomButton isIconButton={true}
                  onClick={() => !item.is_default && onEditItem && onEditItem(cloneDeep({
                    ...item,
                    edit: true
                  }))}
                  disabled={item.is_default}>
                  <CustomIcon icon="edit" />
                </CustomButton>
                <DangerButton isIconButton={true} onClick={() => !item.is_default && setItemClicked({
                  ...item,
                  delete: true
                })} disabled={item.is_default}>
                  <CustomIcon icon="delete" />
                </DangerButton>
              </div>
            </TableBodyItem>
          </tr>


        }

      </tbody>

    </>

  );
};
export { DynamicItemSearchResultTableBody };

function TableBodyItem({ children, extClass }) {
  return (
    <TableCell
      className={`${extClass ? `${extClass} ` : ''}`}>
      {children}
    </TableCell>
  );
}

const AddRemoveItem = ({ item, setItemToSelected }) => {

  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage));

  const {
    loading = false,
    data: selectedDataList = [],
    error = ""
  } = useSelector((state) => state.dynamicUi.selected[selectedPage]) ?? {};

  const dataSelection = useMemo(() =>
    selectedDataList.find((i) => item.id === i.section?.id), [selectedDataList, item]);

  const isMobileViewSelected = useSelector((state) => state.dynamicUi.isPlatformMobile);

  const canAdd = item.platform === PLATFORM_BOTH || isMobileViewSelected && item.platform === PLATFORM_MOBILE || !isMobileViewSelected && item.platform === PLATFORM_WEB;


  return (
    <>
      {dataSelection ?
        <CustomIcon icon="remove_circle_outline"
          className={`${canAdd ? 'text-error-500 hover:text-error-100 cursor-pointer' : 'text-gray-300'}`}
          onClick={() => !canAdd ? null : setItemToSelected({
            ...item,
            remove: true,
            sectionId: dataSelection.id
          })}
          size="xxl" title="Remove from the UI" /> :
        <CustomIcon icon="add_circle_outline"
          className={`${loading || !!error || !canAdd ? 'text-gray-300' : 'text-primary-500 hover:text-primary-100 cursor-pointer'}`}
          onClick={() => loading || !!error || !canAdd ? null : setItemToSelected(item)} size="xxl"
          title="Add to the UI" />}

    </>
  );
};




